import {
  CORE, gatewayShortJson,
} from '../../api';

export function findGeradoresRelatoriosTipoPrestacao() {
  return gatewayShortJson.get(`${CORE}/relatorio/geradores?idTipoGeradorRelatorio=0`);
}
